import { render, staticRenderFns } from "./NbPaxTile.vue?vue&type=template&id=71c77834"
import script from "./NbPaxTile.vue?vue&type=script&lang=js"
export * from "./NbPaxTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports